import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "div" ];

  HIDE_TIMEOUT = null;

  connect()
  {
    this.divTarget.addEventListener("mouseover", e =>
    {
      clearTimeout(this.HIDE_TIMEOUT);
    })

    this.divTarget.addEventListener("mouseout", e =>
    {
      this.HIDE_TIMEOUT = setTimeout(() => { this.hide() }, 4000);
    })
  }

  close(event) {
    event.preventDefault();
    this.hide();
  }

  show(event) {
    if (this.divTarget.classList.contains("toast-invisible")) {
      this.divTarget.classList.remove("toast-invisible");
      this.divTarget.lastElementChild.innerText = event.detail;

      this.HIDE_TIMEOUT = setTimeout(() => { this.hide() }, 4000);
    }
  }

  hide() {
    if (!this.divTarget.classList.contains("toast-invisible")) {
      this.divTarget.classList.add("toast-invisible");
    }
  }
}